"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfWebfirstDataset = exports.checkIfInviteExpired = exports.formatLastSyncedDate = exports.getOwnerName = void 0;
const luxon_1 = require("luxon");
const constants_1 = require("utils/constants");
const getOwnerName = (grantorFirstName, grantorLastName) => {
    if (!grantorFirstName && !grantorLastName) {
        return constants_1.APP_STRING_NOT_APPLICABLE;
    }
    const firstName = grantorFirstName || '';
    const lastName = grantorLastName || '';
    return `${firstName} ${lastName}`;
};
exports.getOwnerName = getOwnerName;
const formatLastSyncedDate = (date) => {
    const originalDateTime = luxon_1.DateTime.fromISO(date);
    return originalDateTime.toFormat('MM/dd/yy, HH:mm');
};
exports.formatLastSyncedDate = formatLastSyncedDate;
const checkIfInviteExpired = (date) => {
    if (!date) {
        return false;
    }
    const dtNow = luxon_1.DateTime.local();
    const dtLastSent = luxon_1.DateTime.fromISO(date);
    const diff = luxon_1.Interval.fromDateTimes(dtLastSent, dtNow);
    const diffHours = diff.length('hours');
    if (diffHours > 24) {
        return true;
    }
    return false;
};
exports.checkIfInviteExpired = checkIfInviteExpired;
const checkIfWebfirstDataset = (platform) => platform ? ['QWIN_MWF', 'QMAC_MWF'].includes(platform) : false;
exports.checkIfWebfirstDataset = checkIfWebfirstDataset;
